<div class="flex flex-col items-center justify-center h-full text-center">
    <mat-icon class="text-8xl icon-colour mb-12">shopping_cart_checkout</mat-icon>
    <h2 class="text-xl font-bold mb-2">Select a Payment Method</h2>
    <p class="text-gray-600 mb-6">Please select your preferred payment method from the list.</p>
</div>

